<template>
	<div
		id="reception-counter-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="reception-counter-modal"
		data-backdrop="static"
		@keyup.esc.stop.prevent="Close()"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="w-full flex flex-col items-center gap-12">
					<h2 class="text-2xl font-black mb-0">
						SELECIONE UM GUICHÊ
					</h2>

					<CustomSelect
						:options="counters"
						v-model="tempReceptionCounter"
						:interceptSelect="true"
						@select="SelectHandler"
					>
					</CustomSelect>

					<div class="w-full flex justify-between">
						<button
							class="btn btn-danger btn-fixed-size"
							tabindex="6"
							@click="Close"
							:disabled="selectedReceptionCounter === 0"
						>
							CANCELAR
						</button>
						<button
							class="btn btn-success btn-fixed-size"
							tabindex="5"
							@click="SaveReceptionCounter"
						>
							SALVAR
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { useError } from '@/composables'
	import { mapActions, mapGetters } from 'vuex'
	export default {
		name: 'ReceptionCounterModal',
		data() {
			return {
				receptionCounters: 15,
				tempReceptionCounter: null,
				updateReceptionCounter: false,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			...mapGetters('system', ['selectedReceptionCounter']),
			counters() {
				return Array.from(
					{ length: this.receptionCounters + 1 },
					(_, i) => i + 1
				).map(counter => {
					const isLast = this.receptionCounters + 1 === counter

					if (isLast) {
						return {
							value: 'add',
							label: 'ADICIONAR GUICHÊ',
						}
					}

					return {
						value: counter,
						label: `GUICHÊ ${counter}`,
					}
				})
			},
		},
		watch: {
			selectedReceptionCounter: {
				handler(val) {
					if (val === 0) {
						val = 1
					}

					this.tempReceptionCounter = {
						value: val,
						label: `GUICHÊ ${val}`,
					}
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', [
				'StartLoading',
				'FinishLoading',
				'SetSelectedReceptionCounter',
			]),
			Open() {
				const modal = window.jQuery('#reception-counter-modal')
				modal.modal({
					focus: false,
				})
				modal.modal('show')
			},
			Close() {
				if (this.selectedReceptionCounter === 0) return

				window.jQuery('#reception-counter-modal').modal('hide')
				window.jQuery('body').removeClass('modal-open')

				this.$emit('close')
			},
			async SaveReceptionCounter() {
				this.SetSelectedReceptionCounter(
					this.tempReceptionCounter.value
				)

				if (this.updateReceptionCounter) {
					await this.UpdateReceptionCounters()
				}

				this.Close()
			},
			async UpdateReceptionCounters() {
				this.StartLoading()

				return window.api
					.call('post', '/reception/update-reception-counters', {
						organization_id: this.requester_selected_id,
						reception_counters: this.receptionCounters,
					})
					.then(({ status }) => {
						if (status !== 200) {
							useError('ERRO AO ATUALIZAR GUICHÊS')
							return
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			async GetOrganizationReceptionCounters() {
				this.StartLoading()

				return window.api
					.call('post', '/reception/get-reception-counters', {
						organization_id: this.requester_selected_id,
					})
					.then(({ status, data }) => {
						if (status !== 200) {
							useError('ERRO AO BUSCAR GUICHÊS')
							return
						}

						this.receptionCounters = data.reception_counters
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			SelectHandler(option) {
				if (option.value === 'add') {
					this.receptionCounters += 1
					this.tempReceptionCounter = {
						value: this.receptionCounters,
						label: `GUICHÊ ${this.receptionCounters}`,
					}
					this.updateReceptionCounter = true
				} else {
					this.tempReceptionCounter = option
				}
			},
		},
		beforeMount() {
			this.GetOrganizationReceptionCounters()
		},
		async mounted() {
			this.Open()

			window
				.jQuery('#reception-counter-modal')
				.on('hidden.bs.modal', () => {
					window.jQuery('body').removeClass('modal-open')

					this.$emit('close')
				})

			await this.$nextTick()

			setTimeout(() => {
				document
					.querySelector('#reception-counter-modal #close-modal')
					?.focus()
			}, 300)
		},
	}
</script>

<style lang="scss" scoped>
	.modal-content {
		background-color: var(--elementsBackgroundColor);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 3rem;
		border-radius: 0.375rem;
		padding: 2.5rem;
	}

	.btn {
		padding: 0.7rem 1rem;
		color: var(--white);
		outline: none;
		background-color: var(--newPrimaryBackgroundColor);
		border: 1px solid var(--newPrimaryBackgroundColor);
		border-radius: 0.3rem;
		transition: all 0.1s ease-in-out;
		height: unset;
		display: flex;
		align-items: center;
		justify-content: center;

		&.btn-success {
			background-color: var(--successBackgroundColor);
			border-color: var(--successBackgroundColor);

			&:hover {
				background-color: var(--successHoverBackgroundColor);
				border-color: var(--successHoverBackgroundColor);
			}
		}

		&.btn-danger {
			background-color: red;
			border-color: red;

			&:hover {
				background-color: #6f0202;
				border-color: #6f0202;
			}
		}

		&.btn-legacy {
			width: unset;
			height: unset;
			padding: 0.7rem 1rem;
			background-color: var(--backgroundLight);
			border: 1px solid var(--backgroundLight);
			color: var(--fontColor);

			&:hover {
				background-color: var(--backgroundLighter);
				border-color: var(--backgroundLighter);
			}
		}

		&.btn-fixed-size {
			width: 9.3rem;
			height: 3.361rem;
			min-height: unset;
			max-height: unset;
			padding: 0.25rem 1rem;
			font-size: 0.9rem;
		}
	}
</style>
